import moment from 'moment-timezone'
moment.locale('ru')
moment.tz.setDefault('GMT+5')

export default moment



// WEBPACK FOOTER //
// ./src/moment.js